import { render } from "./IconArrow.vue?vue&type=template&id=19227cb9"
import script from "./IconArrow.vue?vue&type=script&lang=js"
export * from "./IconArrow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__